<script>
  import { download } from "../scripts/download";
  let audio;
  let video;

  export let renderedAudio;
  export let renderedVideo;

</script>

<!-- svelte-ignore a11y-media-has-caption -->
<audio
  src={renderedAudio ? URL.createObjectURL(renderedAudio) : undefined}
  style={renderedAudio ? "" : "display : none;"}
  controls
  bind:this={audio}
/>
<!-- svelte-ignore a11y-media-has-caption -->
<video
  src={renderedVideo ? URL.createObjectURL(renderedVideo) : undefined}
  style={renderedVideo ? "" : "display : none;"}
  controls
  bind:this={video}
/>

<div class="grid">
  <ion-button
    color="dark"
    shape="round"
    style={renderedAudio ? "" : "display : none;"}
    on:click={() => {
      download("mp3");
    }}
  >
    Download Audio
  </ion-button>
  <ion-button
    color="dark"
    shape="round"
    style={renderedVideo ? "" : "display : none;"}
    on:click={() => {
      download("mp4");
    }}
  >
    Download Video
  </ion-button>
</div>

<style>
  audio {
    width: 100%;
  }

  div.grid {
    display: flex;
  }

</style>
